import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    page: {
        position: 'relative',
        width: '100%',
        height: '100%',
        fontFamily: 'Helvetica',
    },
    backgroundImage: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        zIndex: -1,
        top: 0,
        left: 0,
    },
    tableContainer: {
        marginTop: 16,
        paddingHorizontal: 16,
    },
    table: {
        display: 'table',
        width: 'auto',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: '#d9d9d9',
    },
    tableRow: {
        flexDirection: 'row',
        borderBottomColor: '#d9d9d9',
        borderBottomWidth: 1,
    },
    tableHeader: {
        backgroundColor: '#826320',
        padding: 5,
        fontWeight: 'bold',
        color: "#fff"
    },
    tableCell: {
        padding: 5,
        fontSize: 10,
        flex: 1,
        borderRightColor: '#d9d9d9',
        borderRightWidth: 1,
        wordBreak: 'break-word',
        minWidth: 50,
    },
    lastCell: {
        borderRightWidth: 0,
    },
    logoContainer: {
        width: '100%',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        padding: 10
    },
    logo: {
        width: 183,
        height: 54
    }
});

// landscape, portrait
const PDFGenerator = ({ data = [], columns = [], orientation = 'portrait', formatCell, rowsPerPage }) => {
    const pages = Array.from({ length: Math.ceil(data?.length / rowsPerPage) }, (_, pageIndex) => {
        const start = pageIndex * rowsPerPage;
        const end = start + rowsPerPage;
        return data?.slice(start, end);
    });

    return (
        <Document>
            {pages.map((chunk, pageIndex) => (
                <Page size="A4" style={styles.page} key={pageIndex} orientation={orientation}>
                    {/* Table Content */}
                    <View style={styles.tableContainer}>
                        {/* Table Header */}
                        <View style={styles.table}>
                            <View style={styles.tableRow} fixed>
                                {columns.map((col, idx) => (
                                    <Text style={[styles.tableCell, styles.tableHeader]} key={idx}>
                                        {col.label}
                                    </Text>
                                ))}
                            </View>

                            {/* Table Rows */}
                            {chunk?.map((item, rowIdx) => (
                                <View style={styles.tableRow} key={rowIdx}>
                                    {columns.map((col, idx) => (
                                        <Text style={styles.tableCell} key={idx}>
                                            {item[col.key] !== undefined && item[col.key] !== null && item[col.key] !== ''
                                                ? formatCell
                                                    ? formatCell(col.key, item[col.key])
                                                    : item[col.key]
                                                : '-'}
                                        </Text>
                                    ))}
                                </View>
                            ))}
                        </View>
                    </View>
                </Page>
            ))}
        </Document>
    );
};

export default PDFGenerator;
